import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NoticeProvider } from './context/NoticeContext';
import { ThemeProvider } from './context/ThemeContext';
import Routes from './routes';
import './index.css';

function App() {
  return (
    <ThemeProvider>
      <NoticeProvider>
        <AuthProvider>
          <Router>
            <Routes />
          </Router>
        </AuthProvider>
      </NoticeProvider>
    </ThemeProvider>
  );
}

export default App;